import { useProfile } from '@src/features/profile/contexts/profile-context';

import { LinkTripOrStartExploring } from './link-trip-or-explore';
import { SignInAndBook } from './sign-in-and-book';

export const NoTripsHeader = () => {
  const { data, isLoading } = useProfile();

  if (isLoading) return null;

  const isAuthenticated = !!data;

  return <>{isAuthenticated ? <LinkTripOrStartExploring /> : <SignInAndBook />}</>;
};
